export default "__VITE_ASSET__CcgWXNTj__"